import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class LocationService {
  constructor(private http: HttpUtilService) {}

  getAll(): Observable<any> {
    return this.http.get("LocationService.asmx/GetAll");
  }

   getLocationDetail(id: string): Observable<any> {
    return this.http.get(`LocationService.asmx/GetLocationDetail?id=%22${id}%22`);
  }

  updateLocation(payload: any): Observable<any> {
    return this.http.post("LocationService.asmx/Update", {
      model: payload,
    });
  }

  addLocation(payload: any): Observable<any> {
    return this.http.post("LocationService.asmx/Add", {
      model: payload,
    });
  }

  deleteLocations(items: any[]): Observable<any> {
    return this.http.post("LocationService.asmx/Delete", { items });
  }
}
